export default __webpack_public_path__ + "static/media/jobEmpty.0fbea04a.svg";